import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { CmsNavigationComponent, CmsNavigationNode, UserIdService } from '@spartacus/core';
import { CmsComponentData, NavigationService } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { customDeviceStylings } from 'src/app/service/custom-device-stylings/custom-device-stylings.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-header-links',
  templateUrl: './header-links.component.html',
  styleUrls: ['./header-links.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeaderLinksComponent implements OnInit, OnDestroy {
  headerLinksNavNode$: Observable<any> = this.service.getNavigationNode(this.componentData.data$);
  styleClass$: Observable<string> = this.componentData.data$.pipe(map((d) => d.styleClass));
  data$: Observable<CmsNavigationComponent> = this.componentData.data$;
  shimanoHeaderNavNode: CmsNavigationNode;
  DEALER_SELECTOR = 'DealerSelectorNavNode';
  HEADER_LINKS = 'HeaderLinksNavNode';
  MY_ACCOUNT = 'B2BAccountNavNode';
  isDealerSelector = false;
  isHeaderLinks = false;
  isMyAccount = false;
  headerLinksSubscription$: Subscription;

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private service: NavigationService,
    private cdr: ChangeDetectorRef,
    protected auth: UserIdService,
    private deviceStylings: customDeviceStylings,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.headerLinksSubscription$ = combineLatest([this.headerLinksNavNode$, this.data$])
      .pipe(
        tap(([headerLinksNavNode, componentData]) => {
          if (headerLinksNavNode) {
            switch (componentData.navigationNode.uid) {
              case this.DEALER_SELECTOR:
                this.isDealerSelector = true;
                break;
              case this.HEADER_LINKS:
                this.isHeaderLinks = true;
                this.shimanoHeaderNavNode = componentData.navigationNode;
                break;
              case this.isB2BAccountNavNode(componentData.navigationNode.uid):
                this.isMyAccount = true;
                break;
            }
          }
        })
      )
      .subscribe(() => {
        if (!(this.cdr as ViewRef).destroyed) {
          this.cdr.detectChanges();
        }
      });
    const elHeaderLinks = document.querySelector('.CenterRightContentSlot');
    if (this.deviceStylings.isTabletMaxWidthExceeds()) {
      elHeaderLinks?.classList?.add('adjustedStylings');
    } else {
      elHeaderLinks?.classList.remove('adjustedStylings');
    }
  }

  isB2BAccountNavNode(uid: string): string {
    if (uid.includes(this.MY_ACCOUNT)) return uid;
  }

  goToDealer() {
    this.auth.setUserId(null);
  }

  getRouterUrl(url: any): any[] {
    if (typeof url === 'string') {
      return [this.getAbsoluteUrl(url)];
    }
    return url;
  }

  getAbsoluteUrl(url: string) {
    return url.startsWith('/') ? url : '/' + url;
  }

  ngOnDestroy() {
    if (this.headerLinksSubscription$) {
      this.headerLinksSubscription$.unsubscribe();
    }
  }
}
